import React, { useState } from 'react'
import { BsCalendar2CheckFill } from 'react-icons/bs'
import Title from '../../Components/Admin/Title'
import useFetchApi from '../../hooks/useFetchApi'
import Swal from 'sweetalert2'
import usePagination from '../../hooks/usePagination'
import { Link } from 'react-router-dom'
import { BOOKING_TABLE_STATUS_URL, BOOKING_TABLE_URL } from '../../utils/Constant'
import { authHeaders } from '../../utils/api'


function Booking() {

    const [address, setAddress] = useState('');
    // const { data, setData, loading, error, refetch: fetchData } = useFetchApi({
    //     url: 'https://orisoftpl.com/backend/api/admin/dashboard',
    //     dataKey: 'recentBookings',
    // });

    // const { data, setData, loading, error, refetch: fetchData } = useFetchApi({
    //     url: BOOKING_TABLE_URL,
    //     dataKey: 'recentBookings',
    //     token: localStorage.getItem("admin_token"), // ✅ auth token
    // });

    const { data, setData, loading, error, refetch: fetchData } = useFetchApi({
        url: BOOKING_TABLE_URL,
        dataKey: 'recentBookings',
        authType: 'admin'// ✅ auth token
    });


    const { currentItems, getVisiblePages, currentPage, setCurrentPage, handlePrev, handleNext, totalPageNo }
        = usePagination({
            data: data,
            itemShowPerPage: 5,
        })

    const handleApprove = async (id) => {
        const result = await Swal.fire({
            title: "Are you sure?",
            text: "You want to approve this booking",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, Approve",
            cancelButtonText: "Cancel",
            confirmButtonColor: "#22c55e",
            cancelButtonColor: "#ef4444",
        });
        if (!result.isConfirmed) return;
        try {




            const res = await fetch(BOOKING_TABLE_STATUS_URL, {
                method: "POST",
                headers: authHeaders(),
                body: JSON.stringify({ id, status: 2 }),
            });

            console.log('res:--', res);


            if (!res.ok) throw new Error(`Server error: ${res.status}`);

            const data = await res.json();

            if (data.success) {
                console.log('data success');

                Swal.fire({
                    title: "Approved!",
                    text: "Booking approved successfully",
                    icon: "success",
                    timer: 1500,
                    showConfirmButton: false,
                });
                fetchData(); // refresh table
            } else {
                console.log('data not success');
                Swal.fire({
                    title: "Error",
                    text: data.message || "Something went wrong",
                    icon: "error",
                });
            }

        } catch (error) {
            // ❌ Network / unexpected error
            Swal.fire({
                title: "Error",
                text: error.message || "Something went wrong",
                icon: "error",
            });
        }
    }

    const handleReject = async (id) => {

        console.log('STEP 1 - reject clicked', id);

        const result = await Swal.fire({
            title: "Are you sure?",
            text: "You want to Reject this booking",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, Reject",
            cancelButtonText: "Cancel",
        });

        console.log('STEP 2 - swal result', result);

        if (!result.isConfirmed) return;

        console.log('STEP 3 - before fetch');

        try {

            const res = await fetch(BOOKING_TABLE_STATUS_URL, {
                method: "POST",
                headers: authHeaders(),
                body: JSON.stringify({
                    id,
                    status: 3,
                }),
            });

            console.log('STEP 4 - fetch response', res);

        } catch (error) {
            console.log('STEP 5 - error', error);
        }
    };


    const showAddress = (id) => {
        const newAddrs = data.find((item) => item.id === id)
        // setAddress()
        console.log('newAddrs', newAddrs);

        setAddress(newAddrs.address);

        document.getElementById('my_modal_3').showModal();
    }
    return (
        <>
            <Title icon={BsCalendar2CheckFill} title='Bookings' />

            <div className="bg-white rounded shadow-lg mt-5">
                <h4 className="text-lg p-4 font-semibold border-b flex justify-between items-center" >
                    Bookings
                    <Link to="/admin/add-bookings" className='btn btn-accent btn-sm text-white shadow-md' >Add Booking</Link>
                </h4>
                <div className="p-4 ">
                    <table className="border w-full">
                        <thead className='bg-gray-400 border p-2'>
                            <tr className="border p-2">
                                <th className="border p-2">Sl No.</th>
                                <th className="border p-2">Ref No</th>
                                <th className="border p-2">Mobile</th>
                                <th className="border p-2">Users</th>
                                <th className="border p-2">Address</th>
                                <th className="border p-2">Mandap</th>
                                <th className="border p-2">Date</th>
                                <th className="border p-2">Price</th>
                                <th className="border p-2">Status</th>
                                <th className="border p-2">Action</th>
                            </tr>
                        </thead>
                        <tbody className='border p-2'>
                            {currentItems.map((item, index) => {
                                const { from_date, to_date, price, status_label, status_badge, payment_label, payment_badge, id, booking_ref, mobile, address } = item
                                const userName = item.user?.name
                                const mandapName = item.mandap?.name
                                return (
                                    <tr className='border p-2' key={id} >
                                        <td className='border p-2 text-sm'>{index + 1}</td>
                                        <td className='border p-2 text-sm'>{booking_ref}</td>
                                        <td className='border p-2 text-sm'>{mobile}</td>
                                        <td className='border p-2 text-sm'>{userName}</td>
                                        <td className='border p-2 text-sm'>
                                            {/* <button onClick={() => showAddress()} className='badge badge-sm badge-outline'>address</button> */}
                                            <button className="badge badge-sm badge-outline" onClick={() => showAddress(id)}>show address</button>
                                        </td>
                                        <td className='border p-2 text-sm'>{mandapName}</td>
                                        <td className='border p-2 text-sm'>{`${from_date} - ${to_date}`}</td>
                                        <td className='border p-2 text-sm'><b>{`₹`}</b>{`${price}`}</td>
                                        <td className='border p-2 text-sm'>
                                            <span className={`badge badge-${status_badge} badge-outline`}>{status_label}</span>

                                        </td>
                                        <td className='border p-2 text-sm'>
                                            <div className="dropdown dropdown-end">
                                                <div tabIndex={0} role="button" className="btn btn-xs btn-info m-1">Action</div>
                                                <ul tabIndex={0} className="dropdown-content menu bg-base-100 rounded-box z-[1] w-52 p-2 shadow">
                                                    <li>
                                                        <button
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                e.stopPropagation();
                                                                handleApprove(id);
                                                            }}
                                                            className="text-green-500"
                                                        >
                                                            Approve
                                                        </button>
                                                    </li>
                                                    <li>
                                                        <button
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                e.stopPropagation();
                                                                handleReject(id);
                                                            }}
                                                            className="text-red-500"
                                                        >
                                                            Reject
                                                        </button>
                                                    </li>
                                                </ul>
                                            </div>
                                        </td>
                                    </tr>
                                )
                            })}

                        </tbody>

                    </table>

                    <div className="paginationContiner flex justify-between items-center my-4">
                        <button
                            className='btn btn-outline'
                            onClick={handlePrev}
                        >Prev</button>
                        <div className="join">
                            {getVisiblePages().map((page) => (
                                <button
                                    onClick={() => setCurrentPage(page)}
                                    className={`join-item btn btn-sm ${currentPage === page
                                        ? "btn-primary text-white"
                                        : "btn-outline"
                                        }`}
                                >
                                    {page + 1}
                                </button>
                            ))}
                        </div>

                        <button
                            className='btn btn-outline'
                            onClick={handleNext}
                        >Next</button>
                    </div>
                </div>
            </div >

            {/* <button className="btn" onClick={() => document.getElementById('my_modal_3').showModal()}>open modal</button> */}
            <dialog id="my_modal_3" className="modal">
                <div className="modal-box">
                    <form method="dialog">
                        {/* if there is a button in form, it will close the modal */}
                        <button className="btn btn-sm btn-circle btn-ghost absolute right-2 top-2">✕</button>
                    </form>
                    <h3 className="font-bold text-lg">Address!</h3>
                    <p className="py-4">{address}</p>
                </div>
            </dialog>
        </>
    )
}

export default Booking